module.exports = __webpack_public_path__ + "img/tick.08f37e36.png";